import LegalDoc from "./LegalDoc";

export default function PoliticaRimborso() {
  return (
    <LegalDoc
      field="legal_refund"
      overline="Recesso e rimborsi"
      title={<>Politica di <span className="italic text-[#D47738]">rimborso</span></>}
      related={[
        { to: "/condizioni-acquisto", label: "Condizioni di acquisto" },
        { to: "/condizioni-consegna", label: "Condizioni di consegna" },
      ]}
    />
  );
}
